import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import Loading from "../../system/components/Loading";
import ReactTable from "react-table";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import Aux from "../../system/containers/Aux";
import Toolbar from "./components/Toolbar";
import PageHeader from "../../system/components/PageHeader";
import { WrappedTable, filterString } from "../../system/containers/Table";

import { actionCreators } from "../../store/countries";

const CheckboxTable = checkboxHOC(ReactTable);
const columns = [
  {
    accessor: "name.address",
    Header: "Country",
    filterMethod: filterString,
    Cell: (props) => (
      <a href={"/countries/edit/" + props.original.id}>{props.value}</a>
    ),
  },
  {
    accessor: "iso_code",
    Header: "ISO Code",
    FilterMethod: filterString,
  },
  {
    accessor: "region.name",
    Header: "Region",
    FilterMethod: filterString,
  },
  {
    accessor: "created_at",
    Header: "Created",
    filterable: false,
    Cell: (props) => moment(props.value).format("DD/MM/YYYY"),
  },
];

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: [],
    };
  }

  componentWillMount() {
    this.props.dispatch(actionCreators.fetchAll());
  }

  remove() {
    let items = this.props.selected;
    if (items.length === 0) {
      return alert("You have not selected any countries");
    }
    const result = window.confirm(
      "Are you sure you want to remove these countries?"
    );
    if (result) {
      this.props.dispatch(actionCreators.delete(items));
    }
  }

  render() {
    const { data, permissions, checkboxProps, loading } = this.props;
    if (loading) {
      return <Loading />;
    }
    return (
      <Aux>
        <PageHeader title="Countries" />
        <Toolbar
          permissions={permissions}
          createLink={"/countries/create"}
          total={data.length}
          handleDelete={() => this.remove()}
        />
        <Scrollbars
          style={{ width: "100%", height: "100%", paddingBottom: "60px" }}
        >
          <CheckboxTable
            ref={(r) => (this.checkboxTable = r)}
            data={data}
            keyField="id"
            showPaginationBottom
            filterable
            columns={columns}
            loading={data.loading}
            defaultPageSize={20}
            style={{
              height: "100vh",
            }}
            className="-striped -highlight"
            {...checkboxProps}
          />
        </Scrollbars>
      </Aux>
    );
  }
}

function mapStateToProps(store) {
  return {
    permissions: store.auth.permissions,
    data: store.countries.list,
    loading: store.countries.loading,
  };
}

const WrapTable = WrappedTable(List);

export default connect(mapStateToProps)(WrapTable);



// WEBPACK FOOTER //
// ./src/containers/Country/List.jsx